// src/Components/Admin/SettingsAIPrompts.js

import React from 'react';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';

const ORANGE_COLOR = '#FF9900';
const DARK_BLUE = '#00008B';
const LIGHT_BLUE_BG = '#E3F2FD';

export default function SettingsAIPrompts({ descriptionPrompt, setDescriptionPrompt }) {
  return (
    <>
      <Typography sx={{ color: '#000000', fontWeight: 'normal', mb: 0.5 }}>
        AI Prompts
      </Typography>
      <TableContainer sx={{ mt: 1 }}>
        <Table size='small' sx={{ '& td, & th': { border: 0, py: 0.25, px: 1 } }}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ width: '40%', verticalAlign: 'top', pt: 1 }}>
                <Typography
                  sx={{
                    color: '#000000',
                    fontWeight: 'normal',
                    fontSize: '0.85rem',
                  }}>
                  Description Prompt
                </Typography>
              </TableCell>
              <TableCell colSpan={2}>
                <TextField
                  fullWidth
                  multiline
                  placeholder='prompt'
                  value={descriptionPrompt}
                  onChange={(e) => setDescriptionPrompt(e.target.value)}
                  variant='standard'
                  size='small'
                  InputProps={{
                    disableUnderline: true,
                    style: {
                      fontSize: '0.8rem',
                      fontWeight: 'normal',
                      color: DARK_BLUE,
                      lineHeight: 1.5,
                    },
                  }}
                  sx={{
                    backgroundColor: LIGHT_BLUE_BG,
                    px: 1,
                    py: 0.5,
                    borderRadius: 1,
                    border: `1px solid ${ORANGE_COLOR}`,
                    '& .MuiInputBase-input': {
                      color: DARK_BLUE,
                      fontWeight: 'normal',
                    },
                    '&:hover': { backgroundColor: LIGHT_BLUE_BG },
                    '&:focus-within': { backgroundColor: LIGHT_BLUE_BG },
                  }}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
